var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "MuiSvgIcon-root MuiSvgIcon-colorPrimary MuiSvgIcon-fontSizeSmall",
    focusable: "false",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.049 6.86441C16.3783 6.86441 16.6252 7.0292 16.7899 7.35876C16.9545 7.60594 16.8723 7.9355 16.7076 8.18268L8.47588 18.0696C8.31124 18.3168 8.06429 18.3992 7.81733 18.3992C7.73502 18.3992 7.57039 18.3992 7.48807 18.3168C7.1588 18.2345 6.91184 17.8225 6.99417 17.4929L7.73502 11.8079H1.23196C0.902693 11.8079 0.655741 11.6431 0.491107 11.396C0.326472 11.0664 0.40879 10.7368 0.573424 10.4897L8.80515 0.602668C9.0521 0.273102 9.46368 0.19071 9.79295 0.355493C10.1222 0.437884 10.3692 0.849842 10.2869 1.17941L9.546 6.86441H16.049ZM9.46366 11.0657L8.96975 14.8557L14.238 8.51153H8.55817C8.39353 8.51153 8.14659 8.42914 7.98195 8.26436C7.89964 8.09958 7.81731 7.85241 7.81731 7.60523L8.2289 3.81523L2.9606 10.1594H8.64049C8.88744 10.1594 9.13439 10.2417 9.29902 10.4065C9.38135 10.5714 9.46366 10.8185 9.46366 11.0657Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/swap.c18d2920.svg";
export { ForwardRef as ReactComponent };